import * as React from "react";
import { useDispatch, useSelector } from "react-redux";

import { useResponsive } from "../../../hooks/useResponsive";
import { setActiveBoards } from "../../../redux/ActiveBoardSlice";
import { setSideBarDrawer } from "../../../redux/Sidebar";
import { user } from "../../../redux/usersSlice";
import { currentUserId, getAPIBaseUrl } from "../../../utils/constants";
import { localStorageInstance } from "../../../utils/localStorage";
import { useAssets } from "../../../reactQuery/domainAssets";
import { useBoards } from "../../../reactQuery/boards";
import { useLoginUser } from "../../../reactQuery/users";
import { getActiveBoards } from "../utils/dashboardUtils";

export function useDashboardPageState() {
  const dispatch = useDispatch();
  const userId = currentUserId();
  const sideBarDrawer = useSelector(
    (state) => state.sideBarDrawer.sideBarDrawer
  );
  const isMobile = useResponsive("down", "md");
  const { data } = useLoginUser(userId);
  const { isLoading, boards, isError } = useBoards();
  const { logo, daily_worklog_reminder } = useAssets();
  const apiUrl = getAPIBaseUrl();
  const [isWorklogRemindExpired, setIsWorklogRemindExpired] = React.useState(
    () => localStorageInstance.getItem("worklog-remind")
  );

  const boardList = React.useMemo(
    () => boards?.data?.data?.responseData || [],
    [boards]
  );

  React.useEffect(() => {
    const syncReminder = () => {
      setIsWorklogRemindExpired(localStorageInstance.getItem("worklog-remind"));
    };

    syncReminder();
    const intervalId = window.setInterval(syncReminder, 10000);
    window.addEventListener("focus", syncReminder);

    return () => {
      window.clearInterval(intervalId);
      window.removeEventListener("focus", syncReminder);
    };
  }, []);

  React.useEffect(() => {
    if (data?.data?.data?.responseData) {
      dispatch(user(data.data.data.responseData));
    }
  }, [data, dispatch]);

  React.useEffect(() => {
    dispatch(setActiveBoards(getActiveBoards(boardList)));
  }, [boardList, dispatch]);

  const openSidebarDrawer = React.useCallback(() => {
    dispatch(setSideBarDrawer(true));
  }, [dispatch]);

  const setSidebarDrawer = React.useCallback(
    (value) => {
      dispatch(setSideBarDrawer(value));
    },
    [dispatch]
  );

  return {
    isMobile,
    sideBarDrawer,
    isLoading,
    isError,
    boards: boardList,
    logo,
    apiUrl,
    daily_worklog_reminder,
    isWorklogRemindExpired,
    openSidebarDrawer,
    setSidebarDrawer,
  };
}
